import React from 'react'
import Button from '../Button'
import Modal from '../Modal'

const IdleTimeoutModal: React.FC = () => {
  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div>
      <Modal.Header title="Session Expired" />
      <Modal.Content>
        <p>
          Your session has expired due to inactivity. Please reload the page to
          continue.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleReload} variant="primary">
          Reload Page
        </Button>
      </Modal.Actions>
    </div>
  )
}

export default IdleTimeoutModal
